const MIN_WINDOW_SIZE = 3;

export type DotsWindow = {
	start: number;
	size: number;
	hasPrevious: boolean;
	hasNext: boolean;
};

/**
 * Computes which dots are visible: all of them when they fit, otherwise a window of
 * `maxDots` centered on the selection. `hasPrevious` / `hasNext` tell if slides are hidden.
 */
export const getDotsWindow = (
	total: number,
	selectedIndex: number,
	maxDots: number
): DotsWindow => {
	const size = Math.min(total, Math.max(maxDots, MIN_WINDOW_SIZE));
	const lastStart = total - size;
	const start = Math.min(Math.max(selectedIndex - Math.floor(size / 2), 0), lastStart);

	return { start, size, hasPrevious: start > 0, hasNext: start < lastStart };
};
